// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"n4-z","colorTextValue":"o4-z","swatches":"p4-z","collapseLink":"q4-z","isCollapsed":"r4-z","dropdown":"s4-z","disabled":"t4-z"};